export const realtor = [
  {
    path: '/r/:alias1',
    isEmbed: false,
    options: false,
  },
  {
    path: '/r/:alias1/step-:step',
    isEmbed: false,
    options: false,
  },
  {
    path: '/r/:alias1/options',
    isEmbed: false,
    options: true,
  },
  {
    path: '/r/:alias1/embed',
    isEmbed: true,
    options: false,
  },
  {
    path: '/r/:alias1/embed/step-:step',
    isEmbed: true,
    options: false,
  },
  {
    path: '/r/:alias1/embed/options',
    isEmbed: true,
    options: true,
  },
  {
    path: '/r/:alias1/:alias2',
    isEmbed: false,
    options: false,
  },
  {
    path: '/r/:alias1/:alias2/step-:step',
    isEmbed: false,
    options: false,
  },
  {
    path: '/r/:alias1/:alias2/options',
    isEmbed: false,
    options: true,
  },
  {
    path: '/r/:alias1/:alias2/embed',
    isEmbed: true,
    options: false,
  },
  {
    path: '/r/:alias1/:alias2/embed/step-:step',
    isEmbed: true,
    options: false,
  },
  {
    path: '/r/:alias1/:alias2/embed/options',
    isEmbed: true,
    options: true,
  },
  {
    path: '/realtor/:alias1',
    isEmbed: false,
    options: false,
  },
  {
    path: '/realtor/:alias1/step-:step',
    isEmbed: false,
    options: false,
  },
  {
    path: '/realtor/:alias1/options',
    isEmbed: false,
    options: true,
  },
  {
    path: '/realtor/:alias1/embed',
    isEmbed: true,
    options: false,
  },
  {
    path: '/realtor/:alias1/embed/step-:step',
    isEmbed: true,
    options: false,
  },
  {
    path: '/realtor/:alias1/embed/options',
    isEmbed: true,
    options: true,
  },
  {
    path: '/realtor/:alias1/:alias2',
    isEmbed: false,
    options: false,
  },
  {
    path: '/realtor/:alias1/:alias2/step-:step',
    isEmbed: false,
    options: false,
  },
  {
    path: '/realtor/:alias1/:alias2/options',
    isEmbed: false,
    options: true,
  },
  {
    path: '/realtor/:alias1/:alias2/embed',
    isEmbed: true,
    options: false,
  },
  {
    path: '/realtor/:alias1/:alias2/embed/step-:step',
    isEmbed: true,
    options: false,
  },
  {
    path: '/realtor/:alias1/:alias2/embed/options',
    isEmbed: true,
    options: true,
  },
];
